<template class="map">
  <v-row no-gutters class="fill-height">
    <v-col class="px-6 pt-2 pb-12 fill-height">
      <h1 class="display-1">
        {{ $t("map") }}
        <span>
          {{ markersLength }} {{$t("total")}}
          <v-btn
            icon
            small
            color="textColor"
            class="refresh"
            @click="refreshData()"
            >
            <v-icon small>mdi-autorenew</v-icon>
          </v-btn>
        </span>
      </h1>
      <h2 class="subtitle-2">{{ $t("mapSubtitle") }}</h2>
      <div class="pt-5 pb-5 d-flex align-end justify-space-between">
      </div>
      <l-map class="mt-6 ml-3" v-if="showMap" :zoom="zoom" :center="center" :options="mapOptions" style="height: 70%; z-index:0;">
        <l-tile-layer :url="url" :attribution="attribution" />
         <v-marker-cluster>
          <div v-for="marker of markers" :key="marker.id + Math.random()">
        
           <l-marker :lat-lng="marker.coord">
           <!--
             <l-icon v-if="marker.domxDevice !== null">
               <img src="@/assets/img/domx_logo_2.png" />
             </l-icon>
             -->
             <l-popup>
               <div>
                 <div>
                   <label>{{ $t("name") }}:</label>
                    {{ marker.client_lastname }}
                 </div>
                 <div>
                   <label>{{ $t("address") }}:</label>
                   {{ marker.address }}
                 </div>
                  <div>
                   <label>{{ $t("tag") }}:</label>
                   {{ marker.tag_id?.split('_').pop() }}
                   </div>
                 <div v-if="marker.make !== null"> 
                 <label>{{ $t("make") }}:</label>
                 {{ marker.make }}
                 </div>
                 <div v-if="marker.model !== null">
                 <label>{{ $t("model") }}:</label>
                 {{ marker.model }}
                 </div>
                 <div>
                  <v-btn rounded class="mb-4 mt-4 mr-2" color="primary" dark
                  @click="selectInstallation(marker);">
                  {{ $t("view_uppercase") }}
                </v-btn>
                 </div>
               </div>
             </l-popup>
           </l-marker>
         </div>
         </v-marker-cluster>
         <TheLoadingIndicator :loading="isLoading" />
       </l-map>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LIcon } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import { Component, Vue, Watch } from 'vue-property-decorator'
import "../styles/MarkerCluster.css";
import "../styles/MarkerCluster.Default.css";
import TheLoadingIndicator from '@/components/TheLoadingIndicator.vue'

import { commonModule, mapModule, filterModule, installationsModule, devicesModule } from '@/store/modules/store-accessor'
import KeycloakSession from '@/helpers/keycloak-session'

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

@Component({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    TheLoadingIndicator,
  }
})

export default class Map extends Vue {
      staticAnchor = [16, 37]
      zoom = 7
      center = latLng(39.638902, 22.946519)
      url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution =
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      withPopup = latLng(39.638902, 22.946519)
      currentZoom = 8
      currentCenter = latLng(39.638902, 22.946519)
      showParagraph = false
      mapOptions = {
        zoomSnap: 0.5,
      }
      showMap = true

  get kcSession() {
    return new KeycloakSession()
  }

  get isDistributor() {
    return this.kcSession.userHasRole('distributor');
  }

  get isTechnicianCompany () {
    return this.kcSession.userHasRole('technician_company');
  }

  get markers() {
    console.log('markers inside map', mapModule.markers);
    return mapModule.markers
  }

  get markersLength() {
    return this.markers.length
  }

  get isLoading() {
    return mapModule.isLoading;
  }

  async selectInstallation(device: any) {
    devicesModule.setIsLoadingTable(true);
    await devicesModule.getDeviceInfo(device.device_id);
    devicesModule.setIsLoadingTable(false);
    if(this.isTechnicianCompany) {

      await installationsModule.getInstallationInfo(device.installation_id);
      commonModule.showSideview({ name: 'devices-sideview' , payload: { installationId: device.installation_id, deviceId: device.device_id} })
    }
    else if(this.isDistributor) {
      commonModule.showSideview({ name: 'distributor-device-sideview' , payload: { installationId: device.installation_id, deviceId: device.device_id} })
    }
  }

  async refreshData() {
    mapModule.getMarkersAction('');
  }

  async mounted () {
    mapModule.getMarkersAction('');
    commonModule.initSnackbar({});
  }
}
</script>

<style scoped lang="scss">

.client-table:not(thead) {
  cursor: pointer;
  min-width: 600px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}


.max-height {
  max-height: 65vh;
  overflow: auto;
}

.placeholder {
  background-color: grey
}

h1 {
  margin-top: 40px;
  font-size: 35px;
  font-weight: 500;
  line-height: 65px;
}

span {
  margin-left: 10px;
  font-size: 18px;
  font-weight: 400;
  color: $pale-purple;
}

label {
  font-size: 12px;
  font-weight: bold;
}

.map {
  position: relative;
}
</style>